import React from 'react';
import {grey600, white} from 'material-ui/styles/colors';
import Paper from 'material-ui/Paper';
import styles from './Footer.css';

class Footer extends React.Component {
    render() {
        let propStyle = {
            backgroundColor: this.props.backgroundColor || white,
            color: this.props.color || grey600
        };
        return (
            <Paper id='left-drawer-footer-id' style={{...styles.container, ...propStyle}}>
                <span style={styles.text}>v0.6 · <a href="https://www.openium.fr">© Openium</a></span>
            </Paper>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// src/components/common/Footer/Footer.js